<template>
  <div class="vadDiscussion">
    <div v-if="!wysiwygIsOpen"
         class="vadDiscussion--bulle is-size-6 vadDiscussion--bulle--has-actions is-cut is-padding-left"
         :class="{'is-classic': isMineComment}"
    >
      <div class="is-margin-bottom-xxsmall">
        <span class="is-size-7">
          <b>Date : </b>{{comment.created_on | prettyDatetime }} -
          <b>Auteur : </b><span v-if="isMineComment">Vous</span><span v-else>{{comment.user_first_name}} {{comment.user_last_name}}</span> ({{comment.user_profil}})
        </span>
      </div>
      <div class="content">
        <p v-html="comment.message"></p>
      </div>
      <div v-if="isMineComment" class="actionsOnRow actionsOnRow--vertical">
        <div>
          <button type="button" @click="openComment">
            <span class="icon is-small"><i class="fal fa-edit"></i></span>
          </button>
        </div>
        <div class="">
          <button type="button" @click="removeComment" class="actionsOnRow-btn--hoverIsDanger">
            <span class="icon is-small"><i class="fal fa-trash-alt"></i></span>
          </button>
        </div>
      </div>
    </div>
    <div v-else class="columns is-gapless">
      <div class="column">
        <wysiwyg-editor
          :light='true' :tooltip-top="true"
          :model="message"
          @change="val => message = val"
          class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless"
        >
        </wysiwyg-editor>
      </div>
      <div class="actionsOnRow actionsOnRow--vertical">
        <div>
          <button class="is-success" type="button" @click="editComment">
            <span class="icon is-small"><i class="fal fa-save"></i></span>
          </button>
        </div>
        <div class="">
          <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="wysiwygIsOpen = false">
            <span class="icon is-small"><i class="fal fa-times"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AdvComment',
    props: {
      comment: {
        type: Object,
        required: true
      },
      idx: Number
    },
    data () {
      return {
        wysiwygIsOpen: false,
        message: null
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isExternal', 'isManager', 'currentUserPk']),
      isMineComment () {
        return this.comment.user === this.currentUserPk
      },
      commentPk () {
        return this.comment.pk
      }
    },
    methods: {
      openComment () {
        this.wysiwygIsOpen = true
        this.$nextTick(() => {
          let selection = document.getSelection()
          let range = document.createRange()
          let contenteditable = document.querySelector('div[contenteditable="true"]')

          if (contenteditable.lastChild.nodeType === 3) {
            range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
          } else {
            range.setStart(contenteditable, contenteditable.childNodes.length)
          }
          selection.removeAllRanges()
          selection.addRange(range)
        })
      },
      editComment () {
        this.$emit('editComment', this.commentPk, { message: this.message })
      },
      removeComment () {
        this.$emit('removeComment', this.commentPk)
      },
      closeEditor () {
        this.wysiwygIsOpen = false
      }
    },
    created () {
      this.message = this.comment.message
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/adv/AdvComment.vue